import * as React from 'react';

import { cn } from '../lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Focus ring matches Input (ring-1, no offset — hugs the border) so textareas and
          // inputs read as one family; the old ring-2 + offset-2 floated a detached band
          // outside the box (#1775 item 5).
          // `thin-scrollbar` (globals.css) themes the native scrollbar — thin rounded thumb,
          // transparent track, light/dark aware — instead of the UA default, which renders as
          // an opaque LIGHT pillar inside dark-mode textareas on classic-scrollbar devices
          // (Windows, macOS "Always"). No-op in apps that don't ship the class.
          'thin-scrollbar flex min-h-[80px] w-full min-w-0 rounded-md border border-input bg-transparent dark:bg-card px-3 py-2 text-sm transition-colors hover:border-muted-foreground/70 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring aria-invalid:border-destructive aria-invalid:hover:border-destructive aria-invalid:focus-visible:ring-destructive disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:hover:border-input read-only:bg-muted read-only:focus-visible:ring-0 read-only:hover:border-input',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
